const BackendApi = {
    login: async (email, password) => {
        const credentials = {
            email: email,
            password: password
        };

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(credentials)
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Login successful:', data);
                localStorage.setItem('token', data.token);
                localStorage.setItem('logged', true);
                return data;
            } else {
                console.error('Login failed');
                throw new Error('Login failed');
            }
        } catch (error) {
            console.error('An error occurred:', error);
            throw error;
        }
    },

    // Alte metode pentru API pot fi adăugate aici
    fetchUserData: async (token) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/user/data`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok) {
                const data = await response.json();
                return data;
            } else {
                console.error('Failed to fetch user data');
                throw new Error('Failed to fetch user data');
            }
        } catch (error) {
            console.error('An error occurred:', error);
            throw error;
        }
    }
};

export default BackendApi;
